/* Styles */
import "../style/base/_common.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_modal.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_images.scss";
import "../style/components/_forms.scss";
import "../style/components/_box.scss";
import "../style/components/_card.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_header.scss";
import "../style/layout/_listing.scss";
import "../style/layout/_insertion.scss";
import "../style/layout/_details.scss";
import "../style/layout/_filters.scss";
import "../style/layout/_pagination.scss";
import "../style/layout/_footer.scss";
import "../style/vendor/_jquery-ui.scss";
import "../style/vendor/_siema.scss";
import "../style/pages/agency.scss";

/* JS */
import "./components/menu";
import "@wikicasa/common/lazy";

//import * as Filters from './components/filters';
import LeafletMap from "@wikicasa/common/leaflet_map";
import * as Favourite from "./components/favourite";
import * as Listing from "./components/listing";
import * as Share from "@wikicasa/common/share";
import type {LatLng} from "leaflet";
import type {IContact} from "./components/contact";
import stickybits from "stickybits";
import {COLORS, MAP_TILER_APIKEY} from "./components/variables";

const map = new LeafletMap();

let Contact: IContact;

declare global {
    interface Window {
        _latitude: number;
        _longitude: number;
        goToMarketingBadge: (arg: string) => void;
    }
}

$(() => {

    /*Filters.init({
        map: "#filters-map",
        form: "#filters-form",
        formMobile: "#filters-form-mobile",
    });*/

    //if (window._serializedSearchBean)
    //    Filters.ready(() => Filters.loadSearch(JSON.parse(window._serializedSearchBean)));

    if (window._serializedSearchBean)
        $("#order").val(`${JSON.parse(window._serializedSearchBean)["filterOrderId"]}`).trigger("change")

    Listing.init({
        list: "#list-properties",
    });

    Favourite.init();

    Share.init();

    initAgencyMap();

    //stickybits("#header", {
    //    useStickyClasses: true
    //});

    // TODO remove this
    $("#mapVisualizationLink").remove();

    $(document).on("click", "[data-phone]", function (e: JQuery.Event) {
        e.preventDefault();

        const self = this;

        import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

            if (!Contact) {
                Contact = module;
                Contact.init();
            }

            Contact.showPhone(e, $(self));
        });
    });
});

function initAgencyMap(): void {

    const $map = $("#map");

    if (map.validateCoordinate(window["_latitude"], window["_longitude"])) {
        map.init($map, MAP_TILER_APIKEY, COLORS);
        map.ready(() => {
            map.addMarker(null, {lat: window["_latitude"], lng: window["_longitude"]} as LatLng, `${window["_baseURL"]}${window["_cdn"]}/_ui/img/Icons/Pin-gi.svg`);
            map.setCenter(window["_latitude"], window["_longitude"], 15);
        });
    } else {
        $map.remove();
    }
}

window["goToMarketingBadge"] = goToMarketingBadge;

export function goToMarketingBadge(baseUrl: string): void {
    window.location.href = baseUrl + "?agency=" + window.location.pathname;
}
